import seelLogo from '@assets/logo.png';
import PropTypes from 'prop-types';

export default function Logo({ scale = 1, styles = {} }) {
  return (
    <img
      src={seelLogo}
      style={{
        display: 'block', width: `${scale * 195}PX`, height: `${scale * 53}PX`, ...styles,
      }}
      alt=""
    />
  );
}
Logo.propTypes = {
  scale: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  styles: PropTypes.object,
};
Logo.defaultProps = {
  scale: 1,
  styles: {},
};
